module.exports = __webpack_public_path__ + "static/media/Group.f35552b3.svg";